import script from "./SettingsApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsApp.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsApp.vue?vue&type=style&index=0&id=998835fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-998835fe"]])

export default __exports__